// Keeps the Render free-tier backend awake by pinging /health every 5 minutes.
// Only runs when REACT_APP_API_URL is set (i.e. in the deployed static-site build).

const BACKEND_BASE = process.env.REACT_APP_API_URL
  ? process.env.REACT_APP_API_URL.replace(/\/api\/v1\/?$/, '')
  : null;

const PING_INTERVAL_MS = 5 * 60 * 1000; // 5 minutes

let intervalId = null;

async function pingBackend() {
  if (!BACKEND_BASE) return;
  try {
    await fetch(`${BACKEND_BASE}/health`, { method: 'GET', cache: 'no-store' });
    console.log('[keep-alive] backend pinged at', new Date().toLocaleTimeString());
  } catch (err) {
    console.warn('[keep-alive] ping failed:', err.message);
  }
}

export function startKeepAlive() {
  if (!BACKEND_BASE) return; // dev mode — no-op
  if (intervalId) return;    // already started

  // Immediate ping to wake the backend as soon as the page loads
  pingBackend();

  intervalId = setInterval(pingBackend, PING_INTERVAL_MS);
}

export function stopKeepAlive() {
  if (intervalId) {
    clearInterval(intervalId);
    intervalId = null;
  }
}
